import { useEffect, useState } from "react";
import {
  useSetEmailNotificationsMutation,
  useSetSmsNotificationsMutation,
  useUserDataQuery,
} from "../../../../_shared/graphql";
import NotificationRow from "../NotificationRow/NotificationRow";

const NotificationPreferences = () => {
  const { data } = useUserDataQuery();
  const [emailToggle, setEmailToggle] = useState(false);
  const [smsToggle, setSmsToggle] = useState(false);

  const [setEmailNotifications] = useSetEmailNotificationsMutation();
  const [setSmsNotifications] = useSetSmsNotificationsMutation();

  useEffect(() => {
    const currentUser = data?.users[0];
    setEmailToggle(!!currentUser?.email_notifications);
    setSmsToggle(!!currentUser?.sms_notifications);
  }, [data]);

  return (
    <div>
      <div className="dashboard-text" style={{ marginTop: 50 }}>
        Notification Preferences
      </div>
      <NotificationRow
        label="Email"
        enabled={emailToggle}
        onToggle={async () => {
          setEmailToggle(!emailToggle);
          await setEmailNotifications({
            variables: { on: !emailToggle },
          });
        }}
      />
      <NotificationRow
        label="SMS"
        enabled={smsToggle}
        onToggle={async () => {
          setSmsToggle(!smsToggle);
          await setSmsNotifications({ variables: { on: !smsToggle } });
        }}
      />
    </div>
  );
};

export default NotificationPreferences;
